import { c as _c } from "react/compiler-runtime";
import type { RefObject } from 'react';
import { DesktopMenuItem } from 'shared/components/navbar/components/menu-link';
import { DesktopMenuSkeletonItems } from 'shared/components/navbar/components/navbar-skeleton';
import { NavigationMenu } from 'shared/components/navbar/components/navigation-menu';
import type { MenuItem } from 'shared/components/navbar/types/menu-item';
import { isMenuLink } from 'shared/components/navbar/utils/is-menu-link';
interface DesktopMenuProps {
  isLoading: boolean;
  isReady: boolean;
  items: MenuItem[];
  menuRef: RefObject<HTMLUListElement | null>;
}

/**
 * The navigation bar owns a single popup that the active trigger hands over to the next one, so
 * moving along the row switches panels without a second hover delay.
 */
export function DesktopMenu(t0) {
  const $ = _c(10);
  const {
    isLoading,
    isReady,
    items,
    menuRef
  } = t0;
  let t1;
  if ($[0] !== isLoading || $[1] !== isReady || $[2] !== items) {
    t1 = isLoading || !isReady ? <DesktopMenuSkeletonItems items={items} /> : items.map(_temp);
    $[0] = isLoading;
    $[1] = isReady;
    $[2] = items;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== menuRef || $[5] !== t1) {
    t2 = <NavigationMenu.List ref={menuRef} className="flex min-w-0 items-center gap-1">{t1}</NavigationMenu.List>;
    $[4] = menuRef;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <NavigationMenu.Portal><NavigationMenu.Positioner className="z-60"><NavigationMenu.Popup><NavigationMenu.Viewport /></NavigationMenu.Popup></NavigationMenu.Positioner></NavigationMenu.Portal>;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2) {
    t4 = <NavigationMenu.Root className="min-w-0">{t2}{t3}</NavigationMenu.Root>;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
function _temp(item) {
  return <DesktopMenuItem item={item} key={isMenuLink(item) ? item.href : item.id} />;
}